import React, { useEffect } from "react";
import styled from "styled-components";
import { MdOutlineDoNotDisturb } from "react-icons/md";
import { useAppSelector } from "../Global/Store";
import { Link, useNavigate } from "react-router-dom";

declare global {
  interface Window {
    FlutterwaveCheckout?: any;
  }
}

const TestPayment = () => {
  const navigate = useNavigate();
  const userName = useAppSelector((state) => state.currentUser);

  // To get the total price of quantity of each items in cart:
  const TotalPrice = (item: any) =>
    item.reduce(
      (allItems: number, oneItem: any) =>
        allItems + oneItem.cartQuantity * oneItem.price,
      0
    );

  const readFromMyCart = useAppSelector((state) => state.cart);

  const shippingEstimate = 0;

  const TaxEstimate = 0;

  const totalTotal =
    TotalPrice(readFromMyCart) + shippingEstimate + TaxEstimate;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.flutterwave.com/v3.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [userName?.name]);

  const handlePayment = () => {
    if (window.FlutterwaveCheckout) {
      window.FlutterwaveCheckout({
        // public_key: "FLWPUBK_TEST-833c54a77bfbb7f86f623880d2ea4518-X",
        public_key: "FLWPUBK-fec7e15906e2283f296b2327c10814f0-X",
        tx_ref: "titanic-48981487343MDI0NzMxvcujeit",
        amount: totalTotal,
        currency: "NGN",
        payment_options: "card, mobilemoneyghana, ussd",
        redirect_url:
          "https://shop-with-mhiz-gee.vercel.app/handle-flutterwave-payment",
        meta: {
          consumer_id: 23,
          consumer_mac: "92a3-912ba-1192a",
        },
        customer: {
          email: `${userName?.email}`,
          phone_number: `${userName?.phoneNum}`,
          name: `${userName?.name}`,
        },
        customizations: {
          title: `SHOP-WITH-MHIZ-GEE`,
          description: "Payment for items purchased",
          logo: "https://www.logolynx.com/images/logolynx/22/2239ca38f5505fbfce7e55bbc0604386.jpeg",
        },
      });
      navigate("/products");
    } else {
      console.error(
        "Flutterwave script not yet loaded or FlutterwaveCheckout is not available!"
      );
    }
  };

  return (
    <div>
      <Container>
        <Wrapper>
          <Title>Order Summary</Title>
          <Summaries>
            <Records>
              <TextDiv>Subtotal</TextDiv>
              <NumberDiv>₦{TotalPrice(readFromMyCart)}</NumberDiv>
            </Records>
            <Records>
              <TextDiv>Shipping estimate</TextDiv>
              <NumberDiv>₦{shippingEstimate}</NumberDiv>
            </Records>
            <Records>
              <TextDiv>Tax estimate</TextDiv>
              <NumberDiv>₦{TaxEstimate}</NumberDiv>
            </Records>
            <Records2>
              <TextDiv2>Order Total</TextDiv2>
              {/* <NumberDiv2>₦{TotalPrice(readFromMyCart) + shippingEstimate + TaxEstimate}</NumberDiv2> */}
              <NumberDiv2>₦{totalTotal}</NumberDiv2>
            </Records2>
          </Summaries>
          {/* <Button>
            <button onClick={handlePayment}>Checkout</button>
          </Button> */}
          {userName?.name ? (
            <>
              <Button>
                <button onClick={handlePayment}>Checkout</button>
              </Button>
            </>
          ) : (
            <>
              <Link style={{ textDecoration: "none" }} to="/register">
                <Button1>
                  <button>Proceed to Checkout</button>
                </Button1>
              </Link>
            </>
          )}
          {/* <Button>
            <button onClick={handlePayment}>Checkout</button>
          </Button> */}
          <Ending>
            <div>
              <MdOutlineDoNotDisturb />
            </div>
            <div>
              Learn more <span>Taxes</span> and <span>Shipping</span>
              Information
            </div>
          </Ending>
        </Wrapper>
      </Container>
    </div>
  );
};

export default TestPayment;

const Container = styled.div`
  display: flex;
  justify-content: center;
  border-left: 1px solid #e4eaee;
  margin-top: 40px;
`;
const Wrapper = styled.div`
  width: 80%;
  height: 100%;
`;
const Title = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: #272727;
`;
const Summaries = styled.div`
  margin-top: 17px;
`;
const Records = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e4eaee;
  font-weight: 500;
  font-size: 14px;
`;
const Records2 = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 20px;
`;
const Button1 = styled.div`
  display: flex;
  justify-content: center;

  button {
    height: 50px;
    background-color: #06a141;
    color: white;
    border: none;
    outline: none;
    border-radius: 40px;
    width: 100%;
    font-weight: bold;
    font-size: 17px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  }
`;
const Button = styled.div`
  display: flex;
  justify-content: center;

  button {
    height: 50px;
    background-color: #06a141;
    color: white;
    border: none;
    outline: none;
    border-radius: 40px;
    width: 100%;
    font-weight: bold;
    font-size: 17px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  }
`;
const Ending = styled.div`
  margin-top: 25px;
  font-size: 15px;
  color: grey;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  span {
    text-decoration: underline;
    font-weight: 500;
    color: #272727;
  }
  div {
    display: flex;
    align-items: center;
  }
`;
const TextDiv = styled.div`
  color: grey;
`;
const TextDiv2 = styled.div`
  color: #272727;
  font-size: 16px;
  font-weight: 700;
`;
const NumberDiv2 = styled.div`
  font-weight: 700;
  color: #272727;
  font-size: 16px;
`;
const NumberDiv = styled.div`
  font-weight: 600;
  color: #272727;
`;
